<template>
    <div class="wrapper">
        <div class="menuWrapper">
            <singleProductMenu 
                ref="singleProductMenuComp"
                @openProductSettings="isSettingsOpen = true"
                @openProductData="isSettingsOpen = false"
            />
        </div>
        <div class="mainBody">
            <div class="singleTab" v-show="!isSettingsOpen && listingData">
                <productData 
                    class="dataContainer"
                    ref="productDataComp"
                    :listingData="listingData"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchProductData='patchProductData'
                    @imageError="console.log('sas')"
                />
                <pricingData 
                    class="dataContainer"
                    ref="productDataComp"
                    :listingData="listingData"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchPricingData='patchProductData'
                />
                <shippingData 
                    class="dataContainer"
                    ref="productDataComp"
                    :listingData="listingData"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchShippingData='patchProductData'
                />
            </div>

            <div class="singleTab" v-show="isSettingsOpen">
                <categorySettings 
                    class="dataContainer"
                    ref="productDataComp"
                    @processProductData='processProductData'
                />
                <statusSettings 
                    class="dataContainer"
                    ref="productDataComp"
                    @processProductData='processProductData'
                />
                <stockSettings 
                    class="dataContainer"
                    ref="productDataComp"
                    @processProductData='processProductData'
                />
            </div>
        </div>
    </div>
</template>
  
<script>
import singleProductMenu from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/menu/menu.vue';

import productData from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/patch/data/product.vue';
import pricingData from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/patch/data/pricing.vue';
import shippingData from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/patch/data/shipping.vue';

import categorySettings from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/patch/settings/category.vue';
import statusSettings from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/patch/settings/status.vue';
import stockSettings from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/patch/settings/stock.vue';

import singleListing from '@/apiFetches(old)/singleListing'
import core from '../api/index.js'
export default {
    name: 'singleProductView',
    components: {
        singleProductMenu,

        productData,
        pricingData,
        shippingData,

        categorySettings,
        statusSettings,
        stockSettings,
    },
    props: {
        shopData: null,
    },
    watch: {
        shopData: {
            handler(newVal) {
                if (newVal) {
                    this.render = true
                    // this.getSingleProductData()
                    // this.setShippingMethods()
                    // this.setShopData()
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        }
    },
    data() {
        return {
            idListing: Number(this.$route.params.idListing),
            listingData: null,
            render: false,
            isSettingsOpen: false,
            activeEntity: null,
            patchError: null,
            patchSuccessful: null

        };
    },
    computed: {
      
    },
    methods: {
        openSettings() {
            this.isSettingsOpen = true
        },

        getSingleProductData() {
            singleListing(this.idListing)
            .then((res) => {
                this.listingData = res.data.listing
            })   
        },

        patchProductData(payload, entity) {
            this.activeEntity = entity
            core.listingApi.patchListing({
                pathParam: this.idListing,
                body: payload
            })
            .then((res) => {
                if(res.status === 'success') {
                    this.$emit('getShopProducts')
                    this.patchError = null

                    this.patchSuccessful = true
                    setTimeout(() => {  
                        this.patchSuccessful = false
                    }, 1500)
                }
                if(res.statusCode === 413) {
                    this.patchError = 'Üks valitud piltidest ületab maksimaalse lubatud pildi suuruse.'
                }
                if(res.message === 'Something went wrong, please try again or contact support.') {
                    this.patchError = 'Midagi läks valesti, palun proovige uuesti või kontakteeruge kasutajatoega.'
                }
                if(res.message === 'Delivery time must be more than 0 and less or equal to 90.') {
                    this.patchError = 'Toote väljasaatmise aeg ei saa olla 0 päeva, samuti mitte rohkem kui 90 päeva. Ajavahemikke sisestada ei ole võimalik'
                }
                if(res.message === 'SKU must contain only letters, numbers, dashes or underscores, be 1-50 characters long, and cannot contain spaces or special characters. Example of valid SKU: "PRODUCT-123" or "winter_boots_2024"') {
                    this.patchError = 'Tootekood tohib sisestada ainult numbreid, tähti, kriispu ja alakriipsu. (näide: "PRODUCT-123" või "winter_boots_2024")'
                }
                if(res.message === 'Cover image must be in the array that holds all images. Try setting new cover image before.') {
                    this.patchError = 'Toote piltide alt on valimata kaanepilt.'
                }
                if(res.message === 'Images have to be supplied.') {
                    this.patchError = 'Puuduvad toote pildid.'
                }
                if(res.message === 'Title length must be atleast 10 characters.') {
                    this.patchError = 'Pealkirja pikkus peab olema vähemalt 10 sõnamärkki.'
                }
                if(res.message === 'Images must be supplied when setting new cover image.') {
                    this.patchError = 'Toote piltide alt on valimata kaanepilt.'
                }
                if(res.message === 'Title length must not exceed 100 characetrs.') {
                    this.patchError = 'Pealkirja pikkus ei saa olla rohkem kui 100 tähemärki.'
                }
                if(res.message === 'Description length must be atleast 50 characters.') {
                    this.patchError = 'Kirjelduse pikkus peab olema vähemalt 50 sõnamärkki.'
                }
                if(res.message === 'Description length cannot exceed 4999 characters.') {
                    this.patchError = 'Kirjelduse pikkus ei saa olla rohkem kui 4999 tähemärki.'
                }
                if(res.message === 'Listing must have a price.') {
                    this.patchError = 'Kuulutusel puudub hind.'
                }
                if(res.message === 'Price is too high.') {
                    this.patchError = 'Määratud hind ei saa olla rohkem kui 9999 eurot.'
                }
                if(res.message === 'Listing must have atleast one tag.') {
                    this.patchError = 'Kategooria on valimata'
                }
                if(res.message === 'Not possible to create a child for a uncategorized tag.') {
                    this.patchError = 'Kategoriseerimata kategooriale ei ole võimalik alakategooriat luua.'
                }
                if(res.message === 'All dimensions must be more than zero.') {
                    this.patchError = 'Sisestage kõik toote mõõdud.'
                }
                if(res.message === 'All dimensions must be of type number.') {
                    this.patchError = 'Toote mõõdud peavad olema numbrid.'
                }
                if(res.message === 'Price of the listing must be a valid currency number.') {
                    this.patchError = 'Hind peab olema valiidne number, mitte rohkem kui kaks komakohta.'
                }
                if(res.message === 'Not possible to add listing to root category.') {
                    this.patchError = 'Kuulutust pole võimalik lisada juurkategooriasse.'
                }
                if(res.message === 'Tags with the provided ids were not found from the database.') {
                    this.patchError = 'Viga kategooria valimisel, proovige uuesti.'
                }
                if(res.message === 'Not possible to add listing to root category.') {
                    this.patchError = 'Juurkategooriasse ei ole võimalik kuulutust lisada, peate valima alakategooria.'
                }
                if(res.statusCode == 413) {
                    this.patchError = 'Piltide suurus megabaitides ületab lubatud maksimumi.'
                }
            })
        },
    },
    created() {
        this.getSingleProductData()
      // Lifecycle hook - called after the instance is created

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
  
<style scoped>
.wrapper {
    background: rgb(238, 242, 245);
    height: 100%;
    min-height: 100vh;
    margin: 0;
}
.menuWrapper {
    display: fixed;
}
.mainBody {
    position: relative;
    width: 1420px;
    margin: 0 auto;
    padding-top: 130px;
}
.singleTab {
    display: flex;
    flex-wrap: wrap;
    row-gap: 35px;
    column-gap: 16px;
}
.dataContainer {
    width: calc(33.33% - 11px);
}
@media (max-width: 1470px) {
    .mainBody {
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
    }
}
@media (max-width: 1200px) {
    .singleTab {
        flex-wrap: wrap;
        column-gap: 1%;
    }
    .dataContainer {
        width: 49%;
    }
}
@media (max-width: 800px) {
    .singleTab {
        column-gap: 0;
    }
    .dataContainer {
        width: 100%;
    }
}
@media (max-width: 500px) {
    .menuWrapper {
        padding-top: 67px;
    }
}
@media (max-width: 420px) {
    .mainBody {
        width: 100%;
        padding-left:0px;
        padding-right:0px;
    }
}
</style>